export default {
  mediacategories: 'Media categories',
  mediacategory: 'Media category',
  verbose_mediacategory: 'a media category',
  select_mediacategories: 'Select a media category',
};
